import { render, staticRenderFns } from "./NavbarDeliveries.vue?vue&type=template&id=4c362e4c&scoped=true&"
import script from "./NavbarDeliveries.vue?vue&type=script&lang=js&"
export * from "./NavbarDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDeliveries.vue?vue&type=style&index=0&id=4c362e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c362e4c",
  null
  
)

export default component.exports